
import React from "react";

// reactstrap components
import {
  Container,
} from "reactstrap";

function DevelopmentHeader() {
  return (
    <>
      <div
        id={'home'}
        className="page-header section-dark"
        style={{
          backgroundImage:
            "url(" + require("assets/img/antoine-barres.jpg") + ")",
        }}
      >
        <div className="filter" />
        <div className="content-center">
          <Container style={{ textAlign: 'center' }}>
            <div className="title-brand">
              <h1 className="presentation-title"> Sprites Development <br></br> Defenders of the Earth </h1>
              <div className="fog-low">
                <img alt="..." src={require("assets/img/fog-low.png")} />
              </div>
              <div className="fog-low right">
                <img alt="..." src={require("assets/img/fog-low.png")} />
              </div>
            </div>
            <h2 className="presentation-subtitle text-center">
              Char Sprite Remaster Evolution Process
            </h2>
          </Container>
        </div>
        <div
          className="moving-clouds"
          style={{
            backgroundImage: "url(" + require("assets/img/clouds.png") + ")", position: 'absolute', zIndex: '-1',
          }}
        />
        <h6 className="category category-absolute">
          Created by
          <a
            href="https://daniloabella.com/"
            rel="noopener noreferrer"
          >
            <img
              alt="..."
              className="creative-tim-logo"
              src={require("assets/img/Index/Daniloabella.png")}
            />
          </a>
        </h6>
      </div>
    </>
  );
}

export default DevelopmentHeader;
